export const issueTriggersInitialState = {
    name: '',
    issue: { name: '', id: null },
    companies: [null],
    taskTemplate: { id: null, name: '' },
    parentTaskTemplates: [],
    parentTaskCycleTemplates: [],
    parentProcessTemplates: []
  }